<template>
  <pop-up-layout 
    :title="localization.title"
    :description="localization.cliente"
    :saving="waitingForLoad"
    :loading="loading"
    :disabled="!cambiado"
    @volver="$parent.hide()"
  >
    <v-col cols="12">
      <v-row class="px-6" justify="center" align="center">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="search" id="search"
            :label="localization.buscar"
          />
        </v-col>
      </v-row>
      <v-row class="px-6" justify="center" align="center">
        <v-col cols="12">
          <v-data-table
            v-model="selected" id="selected"
            :headers="headers"
            :search="search"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': $t('filasPorPagina'),
            }"
            :items="getterClientesEspecialesPromocionByIdPromocion"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  @click="seleccionarCliente(item)"
                  :style="selected.some(x => x.codigo === item.codigo) ? 'background-color: lightgray' : ''"
                >
                  <td class="text-xs-center">{{ item.nombre }}</td>
                  <td class="text-xs-center">{{ item.email }}</td>
                  <td class="text-xs-center">{{ traducirClienteEspe(item) }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    promoId: {
      type: String,
      required: true
    },
    clienteYaSeleccionado: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      waitingForLoad: false,
      selected: null,
      search: null
    }
  },
  async created () {
    try {
      this.loading = true
      await this.getClientesEspecialesPromocionByIdPromocion(this.promoId)
      this.selected = this.clienteYaSeleccionado
      this.loading = false
    } catch (error) {
      this.addAlert({ texto: this.$t('errorCargarClientesEspeciales'), color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      getterClientesEspecialesPromocionByIdPromocion: 'incidencias/getClientesEspecialesPromocionByIdPromocion'
    }),
    localization () {
      return this.$t('popUpSeleccionarClientesEsp')
    },
    headers () {
      return [
        {text: this.$t('popUpSeleccionarClientesEsp.headerNombre'), value: 'nombre', sortable: true, align: 'LEFT'},
        {text: this.$t('popUpSeleccionarClientesEsp.headerEmail'), value: 'email', sortable: true, align: 'LEFT'},
        {text: this.$t('popUpSeleccionarClientesEsp.headerDescription'), value: 'descripcion', sortable: true, align: 'LEFT'}
      ]
    },
    cambiado () {
      return this.clienteYaSeleccionado !== this.selected
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getClientesEspecialesPromocionByIdPromocion: 'incidencias/getClientesEspecialesPromocionByIdPromocion'
    }),
    seleccionarCliente (cliente) {
      this.selected = []
      this.selected.push(cliente)
      this.$emit('clienteSelected', this.selected)
      this.$parent.hide()
    },
    traducirClienteEspe (item) {
      if(this.usuario.idioma === 'spa') {
        return item.descripcion
      } else {
        let traducciones = JSON.parse(item.traduccion)
        if(traducciones) {
          return traducciones[this.usuario.idioma] || item.descripcion
        } else {
          return item.descripcion
        } 
      }
    }
  },
  watch: {
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>